var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeammateAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1569 12.0747L15 12.1419L11.5162 6.24651L10.1961 8.31986H12.1177M6.83332 10.1973H9.2353M6.24997 6.39535L6.13646 6.08537C5.7085 4.9165 4.79662 3.99492 3.64001 3.5624L3.33334 3.44769L3.64001 3.33299C4.79662 2.90047 5.7085 1.97889 6.13646 0.810018L6.24997 0.5L6.36347 0.810018C6.79143 1.97889 7.70331 2.90047 8.85992 3.33299L9.16668 3.44769L8.85992 3.5624C7.70331 3.99492 6.79143 4.9165 6.36347 6.08537L6.24997 6.39535ZM2.75 11.1116C2.49476 10.2642 1.83852 9.60107 1 9.34311C1.83852 9.08514 2.49476 8.42189 2.75 7.57442C3.00523 8.42189 3.66147 9.08514 4.50001 9.34311C3.66147 9.60107 3.00523 10.2642 2.75 11.1116ZM7.99999 7.42558L12.0414 14.5H3.95853L7.99999 7.42558Z",
    stroke: "#5416BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeammateAi);
export default __webpack_public_path__ + "static/media/teammate-ai.06b035011e36947af91b9983b9e8caac.svg";
export { ForwardRef as ReactComponent };